module.exports = __webpack_public_path__ + "static/media/red_plus.c46ab6e9.svg";